export const TOKE_NAME = 'access_token';
export const TOKE_NAME_OAUTH = 'access_token_oauth';
export const CURRENT_FORM_OAUTH = 'current_form_oauth';
export const TOKEN_ID = 'bGliZXJ0eTIwMTk=';
export const USER_SESSION = 'userdata';
export const PATH_PORTAL = 'access_menus';
export const USER_MENUS = 'user_menu';
export const CODE = 'code';
export const CLIENT_ID = 'b5723e8c7bf6f6cc57a781f87c7e0dae';
export const GRAN_TYPE = 'client_credentials';

export class Constantes {
    // Roles
    user_admin = 'rol_admin';
    rolAdminIntermediario = 'admin_intermediario';
    rolAdminIntermediarioPiloto = 'admin_intermediario_piloto';
    rolConsultaIntermediario =  'consulta_intermediario';
    // gestor
    rolConsultaLibertyGeneral = 'consulta_libertygeneral';
    // broker
    rolOperativoIntermediario = 'operativo_intermediario';
    rolSuperAdminLiberty = 'super_adminliberty';

    // Reglas
    // Polizas
    gestionarPoliza = 'poliza:btn:gestionar';
    verFactura = 'poliza:link:verFactura';
    verPoliza = 'poliza:link:verPoliza';
    aceptarPoliza = 'poliza:btn:aceptarPoliza';
    rechazarPoliza = 'poliza:btn:rechazarPoliza';
    observacion = 'poliza:btn:enviarObservacion';


    // gestion Formulario
    gestionForm = 'gestionForm:btn:acciones';
    verFormulario = 'gestionForm:btn:verFormulario';
    verFormPadre = 'gestionForm:btn:verFormPadre';

    //Negocios
    verAutos = 'negocios:btn:autos';
    verPyme = 'negocios:btn:pyme';
    seeActions = 'renovations:btn:actions';
    verHogar = 'negocios:btn:hogar';
    verSearchPortal = 'negocios:btn:searchPortal';
    showOffice = 'negocios:btn:back-office';
}
